export default __webpack_public_path__ + "static/media/muffin_logo.125bb036.svg";